import { Checkbox } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import styles from "./VaeEmailButton.module.css";

interface Props {
    className?: string;
    vaeEnabled: boolean;
    onClick: () => void;
}
export const VaeEmailButton = ({ className, vaeEnabled, onClick }: Props) => {
    const { t } = useTranslation();
    return (
        <div className={`${styles.container} ${className ?? ""}`}>
            <Checkbox checked={vaeEnabled} onChange={() => onClick()} label={t("labels.vae")} title={t("helpTexts.vae")} />
        </div>
    );
};
